module.exports = __webpack_public_path__ + "img/auditing.38dd2a57.png";